module.exports = __webpack_public_path__ + "assets/img/title-1b37523a.png";